jQuery(function ($) {

  function initBlogSlider() {
    var $grid = $('.r6-blog-posts .grid');

    if (!$grid.length) return;

    if ($(window).width() <= 767) {
      if (!$grid.hasClass('slick-initialized')) {
        $grid.slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true,
          arrows: false,
          infinite: false,
          adaptiveHeight: true
        });
      }
    } else {
      if ($grid.hasClass('slick-initialized')) {
        $grid.slick('unslick');
      }
    }
  }

  // Debounce resize event for performance
  let resizeTimer;
  $(window).on('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(initBlogSlider, 150);
  });

  // Run once on load
  $(window).on('load', initBlogSlider);
  $(document).ready(initBlogSlider);

});
